import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  PaymentActionError,
  RegisterPaymentPayload,
  ResultAction,
} from '@cashier/cashier-model';

export interface PaymentRegistrationState {
  resultAction: ResultAction | null;
  error: PaymentActionError | null;
}

export const PAYMENT_REGISTRATION_FEATURE_KEY = 'paymentRegistration';

export const initialPaymentRegistrationState: PaymentRegistrationState = {
  resultAction: null,
  error: null,
};

export const paymentRegistrationSlice = createSlice({
  name: PAYMENT_REGISTRATION_FEATURE_KEY,
  initialState: initialPaymentRegistrationState,
  reducers: {
    resetRegistrationState: (state) => {
      state.resultAction = initialPaymentRegistrationState.resultAction;
      state.error = initialPaymentRegistrationState.error;
    },
    registerPaymentStart: (
      _,
      __: PayloadAction<RegisterPaymentPayload>,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {},
    registerPaymentSuccess: (state, action: PayloadAction<ResultAction>) => {
      state.resultAction = action.payload;
    },
    registerPaymentFailure: (
      state,
      action: PayloadAction<PaymentActionError>,
    ) => {
      state.error = action.payload;
    },
  },
});

export const paymentRegistrationReducer = paymentRegistrationSlice.reducer;

export const {
  registerPaymentSuccess,
  registerPaymentFailure,
  registerPaymentStart,
} = paymentRegistrationSlice.actions;
